import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.icon = bracketIndenting({
	line: "#",
})
